/**
 * shadcn/ui Checkbox (Radix) on the brand tokens. Author: Mahmoud Ragab Ahmed.
 */
import { CheckIcon } from "lucide-react";
import { Checkbox as CheckboxPrimitive } from "radix-ui";

import { cn } from "@/lib/utils";

export function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>): React.JSX.Element {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer size-5 shrink-0 rounded-[4px] border border-edge-hover bg-card transition-colors",
        "data-[state=checked]:border-gold data-[state=checked]:bg-gold data-[state=checked]:text-primary-foreground",
        "disabled:cursor-not-allowed disabled:border-rule-strong",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current"
      >
        <CheckIcon className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}
